"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Danger = exports.Text = exports.Tertiary = exports.Secondary = exports.Primary = exports.Basic = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Link = _interopRequireDefault(require("@material-ui/core/Link"));

var _propTypes = require("prop-types");

var css = _interopRequireWildcard(require("./Button.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ButtonDotLoading = (0, _jsxRuntime.jsxs)("div", {
  css: css.loadWrap,
  children: [(0, _jsxRuntime.jsx)("div", {
    css: css.circle
  }), (0, _jsxRuntime.jsx)("div", {
    css: css.circle
  }), (0, _jsxRuntime.jsx)("div", {
    css: css.circle
  }), (0, _jsxRuntime.jsx)("div", {
    css: css.circle
  })]
});

var Basic = function Basic(_ref) {
  var _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      children = _ref.children,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? undefined : _ref$onClick,
      props = _objectWithoutProperties(_ref, ["loading", "children", "onClick"]);

  var handleClick = function handleClick(event) {
    if (loading || typeof onClick === 'undefined') {
      return;
    }

    onClick(event);
  };

  return (0, _jsxRuntime.jsx)(_Button["default"], _objectSpread(_objectSpread({
    disableElevation: true,
    disableRipple: true,
    onClick: handleClick
  }, props), {}, {
    children: loading ? ButtonDotLoading : children
  }));
};

exports.Basic = Basic;

var Primary = function Primary(props) {
  return (0, _jsxRuntime.jsx)(Basic, _objectSpread({
    color: "primary",
    variant: "contained"
  }, props));
};

exports.Primary = Primary;

var Secondary = function Secondary(props) {
  return (0, _jsxRuntime.jsx)(Basic, _objectSpread({
    color: "secondary",
    variant: "contained"
  }, props));
};

exports.Secondary = Secondary;

var Tertiary = function Tertiary(props) {
  return (0, _jsxRuntime.jsx)(Basic, _objectSpread({
    color: "primary",
    variant: "outlined"
  }, props));
};

exports.Tertiary = Tertiary;

var Text = function Text(_ref2) {
  var href = _ref2.href,
      props = _objectWithoutProperties(_ref2, ["href"]);

  return (0, _jsxRuntime.jsx)(_Link["default"], _objectSpread({
    color: "primary",
    component: href ? 'a' : 'button',
    css: css.text,
    href: href,
    type: href ? undefined : 'button'
  }, props));
};

exports.Text = Text;

var Danger = function Danger(props) {
  return (0, _jsxRuntime.jsx)(Basic, _objectSpread({
    color: "inherit",
    variant: "contained",
    css: css.dangerButton
  }, props));
};

exports.Danger = Danger;
Basic.propTypes = {
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.bool,

  /**
   * Element placed after the children.
   */
  endIcon: _propTypes.node,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _propTypes.bool,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes.string,

  /**
   * Element placed before the children.
   */
  startIcon: _propTypes.node
};
Primary.propTypes = {
  /**
   * If `true`, the button will display a loading animation in place of text.
   */
  loading: _propTypes.bool
};
Primary.defaultProps = {
  loading: false
};
Basic.defaultProps = {
  disabled: false,
  endIcon: undefined,
  fullWidth: false,
  href: undefined,
  startIcon: undefined
};
Text.propTypes = {
  children: _propTypes.node.isRequired,
  disabled: _propTypes.bool,
  href: _propTypes.string,
  onClick: _propTypes.func
};
Text.defaultProps = {
  disabled: false,
  href: undefined,
  onClick: undefined
};